module.exports = __webpack_public_path__ + "img/partner_logo_03pressalit.79e10a6d.jpg";